<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { Badge } from '@smatch/cassiopeia-web-components';

    // Plugins
    import { t } from 'svelte-i18n';

</script>

<Badge
    color = 'quaternary'
    style = 'strong'
    size = 'md'
    label = { $t('component.auction.global.reserved') }
    description = { $t('component.auction.global.reserved_description') }
    css = 'ml-1'
/>